//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  queryInsurerOption,
  queryPlanNameOption,
  calClientProm,
  queryPrepayYearOption,
  queryPlanYearOption,queryChiNameById
} from '../api/api';
import axios from 'axios';
export default {
  data() {
    return {
      insurerId:"",
      planName:"",
      planYear:"",
      prepayYear:"",
      premium:50000,
      isPrepay:true,
      insurerOption:[],
      planNameOption:[],
      planYearOption:[],
      prepayYearOption:[],
      isPrepayOption:[
        {value:true,label:'是'},{value:false,label:'否'}
      ],
      clientPromResult:{
        planName:"",prepayWord:"",prepayRate:"",promWord:"",
        clientPromResultDetailList:[]
      },
      insurerChiName:""
    }
  },
  methods: {
    queryChiNameById(){
      let params = {id:this.insurerId};
      return queryChiNameById(params).then(res=>{
        if(res.errcode==200){
          this.insurerChiName = res.data;
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch((error)=>{
        console.log("queryChiNameById Error");
      });
    },
    queryPrepayYearOption(){
      let params = {insurerId:this.insurerId,planName:this.planName,planYear:this.planYear};
      return queryPrepayYearOption(params).then(res=>{
        if(res.errcode==200){
          let {data:prepayYearOption=[]}=res;
          this.prepayYearOption=prepayYearOption;
          this.prepayYear = this.prepayYearOption[0];
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch((error)=>{
        console.log("queryPrepayYearOption Error");
      });
    },
    queryPlanYearOption(){
      let params = {insurerId:this.insurerId,planName:this.planName};
      return queryPlanYearOption(params).then(res=>{
        if(res.errcode==200){
          let {data:planYearOption=[]}=res;
          this.planYearOption=planYearOption;
          this.planYear = this.planYearOption[0];
          this.queryPrepayYearOption();
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch((error)=>{
        console.log("queryPlanYearOption Error");
      });
    },
    queryPlanNameOption(){
      let params = {insurerId:this.insurerId};
      return queryPlanNameOption(params).then(res=>{
        if(res.errcode==200){
          let {data:planNameOption=[]}=res;
          this.planNameOption=planNameOption;
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch((error)=>{
        console.log("queryPlanNameOption Error");
      });
    },
    queryInsurerOption(){
      return queryInsurerOption().then(res=>{
        if(res.errcode==200){
          let {data:insurerOption=[]}=res;
          this.insurerOption=insurerOption;
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch((error)=>{
        console.log("queryInsurerOption Error");
      });
    },
    calClientProm(){
      this.queryChiNameById();
      var params={insurerId:this.insurerId,planName:this.planName,isPrepay:this.isPrepay,premium:this.premium,planYear:this.planYear,prepayYear:this.prepayYear};
      return calClientProm(params).then(res=>{
        if(res.errcode==200){
          this.clientPromResult = res.data ;
        }else{
          this.$message.error(res.errmsg);
        }
      });
    },



  },
  mounted() {
    this.queryInsurerOption();

  },
  computed: {

  },
  activated(){

  }
}




// WEBPACK FOOTER //
// ./src/views/MobileClientPromResult.vue